module.exports = __webpack_public_path__ + "img/product_1.19f22dd.webp";